if (shippingCalculatorArea) {
  zipcodeInput.placeholder = "Digite seu CEP";
  zipcodeInput.maxLength = "8";
  zipcodeInput.inputMode = "numeric";

  stateFromLocalStorage = window.localStorage.getItem("ViaCepEstado");

  productActionsLoading[0].style = "";
  productActionsLoaded[0].style.display = "none";

  const checkLocalStorage = async () => {
    if (stateFromLocalStorage !== "null") {
      province = stateFromLocalStorage;
      zipcode = zipcodeFromLocalStorage;
    }
  };

  const clearShippingInfo = new MutationObserver((mutationsList, observer) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === "childList" && mutation.target === resultadoFrete) {
        resultadoFrete.innerHTML = "";
        observer.disconnect();
      }
    });
  });

  const checkShippingInfo = new MutationObserver((mutationsList, observer) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === "childList" && mutation.target === resultadoFrete) {
        shippingCalculator[0].classList.remove("active");
        shippingCalculator[0].removeAttribute("disabled");

        observer.disconnect();
      }
    });
  });

  const isRestricted = (province) => {
    productActionsLoading[0].style.display = "none";
    productActionsLoaded[0].style = "";

    const tagsElement = document.getElementById("product-tags");

    const tags = tagsElement
      ? tagsElement.getAttribute("data-tags").split(",")
      : [];

    if (tags[0] !== "" && tags[0] !== province) {
      clearShippingInfo.observe(resultadoFrete, {
        childList: true,
        subtree: true,
      });
    }

    if (tags[0] !== "") {
      if (province === "" || province === null || province.length === 0) {
        productPriceArea[0].style = "";
        productActions[0].style = "";
        productVariantQuantity[0].style = "";
        buyButtons[0].style = "";
        restrictedProductArea[0].style.display = "none";
      } else {
        if (tags.includes("SP")) {
          if (tags[0] !== province) {
            productPriceArea[0].style.display = "none";
            productActions[0].style.display = "none";
            productVariantQuantity[0].style.display = "none";
            buyButtons[0].style.display = "none";
            restrictedProductArea[0].style = "";
          } else {
            productPriceArea[0].style = "";
            productActions[0].style = "";
            productVariantQuantity[0].style = "";
            buyButtons[0].style = "";
            restrictedProductArea[0].style.display = "none";
          }
        }
      }
    } else {
      productPriceArea[0].style = "";
      productActions[0].style = "";
      productVariantQuantity[0].style = "";
      buyButtons[0].style = "";
      restrictedProductArea[0].style.display = "none";
    }
  };

  checkLocalStorage();

  isRestricted(province);

  shippingCalculator[0].classList.add("button");
  shippingCalculator[0].classList.add("button-solid");

  shippingCalculator[0].addEventListener("click", async function () {
    shippingCalculator[0].classList.add("active");
    shippingCalculator[0].setAttribute("disabled", "");

    if (zipcodeInput.value === "") {
      resultadoFrete.innerHTML = "Digite um CEP para continuar";

      shippingCalculator[0].classList.remove("active");
      shippingCalculator[0].removeAttribute("disabled");
    } else {
      zipcode = zipcodeInput.value.trim();

      try {
        const viaCepResponse = await fetch(
          `https://viacep.com.br/ws/${zipcode}/json/`
        );
        const viaCepData = await viaCepResponse.json();

        if (!viaCepData.uf) {
          resultadoFrete.innerHTML = "CEP inválido ou não encontrado.";

          shippingCalculator[0].classList.remove("active");
          shippingCalculator[0].removeAttribute("disabled");
          return;
        }

        isRestricted(viaCepData.uf);

        province = viaCepData.uf;

        checkShippingInfo.observe(resultadoFrete, {
          childList: true,
          subtree: true,
        });
      } catch (error) {
        resultadoFrete.innerHTML = "Erro ao calcular o frete ou CEP inválido.";

        shippingCalculator[0].classList.remove("active");
        shippingCalculator[0].removeAttribute("disabled");
      }
    }
  });

  if (zipcodeFromLocalStorage) {
    zipcodeInput.value = zipcode.replace("-", "");

    setTimeout(() => {
      zipcodeInput.value !== "" && shippingCalculator[0].click();
    }, 5000);
  }

  zipcodeInput.addEventListener("input", function () {
    resultadoFrete.innerHTML = "";

    this.value = this.value.replace(/\D/g, "");
  });

  zipcodeInput.addEventListener("keypress", (event) => {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  });

  zipcodeInput.addEventListener("paste", (event) => {
    let paste = (event.clipboardData || window.clipboardData).getData("text");
    if (/\D/.test(paste)) {
      event.preventDefault();
    }
  });
}
